import { useNavigate } from "react-router-dom";
import { Button } from "~components";
import { Css } from "~generated/css";
import { useTestIds } from "~utils";

type AuthToggleLinkProps = {
  mode: "signIn" | "signUp";
};

export function AuthToggleLink(props: AuthToggleLinkProps) {
  const { mode } = props;
  const navigate = useNavigate();
  const isSignIn = mode === "signIn";
  const tid = useTestIds(props, "authToggleLink");

  return (
    <Button
      {...tid}
      variant="link"
      onClick={() => {
        if (isSignIn) {
          // If we go from Sign In to Sign Up we want to start at the form screen
          // bypassing the landing page that is only shown if the user is coming from a QR code scan.
          navigate("/signUp", { state: { step: "signUpForm" } });
        } else {
          navigate("/signIn");
        }
      }}
      xss={Css.mxa.$}
    >
      {isSignIn ? "Don't have an account? " : "Already have an account? "}
      <span css={Css.bpBlue.$}>{isSignIn ? "Sign up" : "Log in"}</span>
    </Button>
  );
}
